export default __webpack_public_path__ + "static/doodle-arrow3-mask-b1d8d3ed1a66c9b401001189c41f040a.png";